export default __webpack_public_path__ + "static/media/2090.f5bd8453.png";